import React, { Component } from "react";

// CSS
import "../../../css/profile/profile-table.css";

class ProfileTable extends Component {
	render() {
		return (
			<table className={`profile-form ` + (!!this.props.classes ? this.props.classes : ``)}>
				<tbody>{this.props.children}</tbody>
			</table>
		);
	}
}

export default ProfileTable;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ProfileTable.js